import { Select } from '@sgcmpteltd/uikit-react';
import {
  MENU_BORDER_RADIUS_LARGE,
  SELECT_SIZE_SM,
} from '@sgcmpteltd/uikit-react/components/select';
import cx from 'clsx';
import { useMemo } from 'react';

import {
  SELECT_MENU_CLOSE_DELAY_MSEC,
} from '../../../../../app/(routes)/listing/_components/page-content/constants';
import styles from './styles.module.scss';
import type { Component } from './types';

export const Range: Component = ({
  name,
  lowerSelectOption,
  upperSelectOption,
  lowerValue,
  upperValue,
  onChange,
}) => {
  const handleLowerSelectChange = (v: string | number) => {
    const lowerOption = lowerSelectOption.optionList
      .find(opt => opt.value === v);
    const upperOption = upperSelectOption.optionList
      .find(opt => opt.value === upperValue.value);

    lowerSelectOption.onChange?.(v);
    onChange?.({
      name,
      type: 'range',
      lowerValue: {
        text: lowerOption?.text || '',
        value: lowerOption?.value || '',
      },
      upperValue: {
        text: upperOption?.text || '',
        value: upperOption?.value || '',
      },
    });
  };

  const handleUppderSelectChange = (v: string | number) => {
    const lowerOption = lowerSelectOption.optionList
      .find(opt => opt.value === lowerValue.value);
    const upperOption = upperSelectOption.optionList
      .find(opt => opt.value === v);

    upperSelectOption.onChange?.(v);
    onChange?.({
      name,
      type: 'range',
      lowerValue: {
        text: lowerOption?.text || 'Lowest',
        value: lowerOption?.value || '',
      },
      upperValue: {
        text: upperOption?.text || 'Highest',
        value: upperOption?.value || '',
      },
    });
  };

  const lowerSelectOptionList = useMemo(() => {
    const index = upperSelectOption.optionList.findIndex(
      opt => opt.value === upperValue.value,
    );

    if (index === -1) return lowerSelectOption.optionList;

    return lowerSelectOption.optionList.map((option, idx) => {
      if (idx >= index) {
        return { ...option, isDisabled: true };
      }
      return option;
    });
  }, [lowerSelectOption.optionList, upperSelectOption.optionList, upperValue]);

  const upperSelectOptionList = useMemo(() => {
    const index = lowerSelectOption.optionList.findIndex(
      option => option.value === lowerValue.value,
    );

    if (index === -1) return upperSelectOption.optionList;

    return upperSelectOption.optionList.map((option, idx) => {
      if (idx <= index) {
        return { ...option, isDisabled: true };
      }
      return option;
    });
  }, [lowerSelectOption.optionList, lowerValue, upperSelectOption.optionList]);

  return (
    <div className={styles.containerRoot}>
      <div className={styles.containerSelect}>
        <Select
          headerClassName={cx(
            styles.selectRoot,
            styles.containerSelectHead,
            lowerValue.value ? styles.activeSelect : '',
          )}
          menuBorderRadius={MENU_BORDER_RADIUS_LARGE}
          menuClassName={cx(
            styles.menuClassName,
            styles.menuHeight,
          )}
          menuCloseDelayMsec={SELECT_MENU_CLOSE_DELAY_MSEC}
          menuContainerClassName={cx(
            styles.menuContainerClassName,
            styles.isRound,
          )}
          optionList={lowerSelectOptionList}
          placeholder={lowerSelectOption.placeholder}
          size={SELECT_SIZE_SM}
          value={lowerValue.value}
          onChange={handleLowerSelectChange} />
      </div>
      <span className={styles.textTo}>to</span>
      <div className={styles.containerSelect}>
        <Select
          headerClassName={cx(
            styles.selectRoot,
            styles.containerSelectHead,
            upperValue.value ? styles.activeSelect : '',
          )}
          menuBorderRadius={MENU_BORDER_RADIUS_LARGE}
          menuClassName={cx(
            styles.menuClassName,
            styles.menuHeight,
          )}
          menuCloseDelayMsec={SELECT_MENU_CLOSE_DELAY_MSEC}
          optionList={upperSelectOptionList.toReversed()}
          placeholder={upperSelectOption.placeholder}
          size={SELECT_SIZE_SM}
          value={upperValue.value}
          onChange={handleUppderSelectChange} />
      </div>
    </div>
  );
};
